function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useEffect } from 'react';
import _ from 'lodash';
import { useDataApi } from '@adsk/alloy-helpers';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { buildGetAccountOfferingsRequest } from './utils';
export var extractProducts = function extractProducts(offerings) {
  if (!offerings) {
    return [];
  }
  return _.chain(offerings).map(function (offering) {
    return offering.products.map(function (product) {
      return _objectSpread(_objectSpread({}, product), {}, {
        included: offering.type.toUpperCase() === 'NONE' ? false : product.included
      });
    });
  }).flatten().orderBy('included', 'desc').unionBy('type').value();
};

/**
 * @param {boolean} enable
 * @param {string} [userAccountId] - The account id selected by the user while
 * creating a new project
 */
var useGetAccountOfferings = function useGetAccountOfferings() {
  var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var userAccountId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var currentAccountId = useCurrentAccountId();
  var accountId = userAccountId !== null && userAccountId !== void 0 ? userAccountId : currentAccountId;
  var _useDataApi = useDataApi(),
    offeringsData = _useDataApi.data,
    offeringsError = _useDataApi.error,
    offeringsDataLoading = _useDataApi.loading,
    doGetAccountOfferings = _useDataApi.doFetch;
  useEffect(function () {
    if (!accountId || !enable) return;
    doGetAccountOfferings(buildGetAccountOfferingsRequest(accountId));
  }, [accountId, enable, doGetAccountOfferings]);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    offeringProducts = _useState2[0],
    setProducts = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoadingOfferingProducts = _useState4[0],
    setIsLoadingOfferingProducts = _useState4[1];
  useEffect(function () {
    setIsLoadingOfferingProducts(offeringsDataLoading);
    if (offeringsData && offeringsData.results && !offeringsError && enable) {
      setProducts(extractProducts(offeringsData.results));
    }
  }, [enable, offeringsData, offeringsDataLoading, offeringsError]);
  return {
    offeringProducts: offeringProducts,
    isLoadingOfferingProducts: isLoadingOfferingProducts
  };
};
export default useGetAccountOfferings;
//# sourceMappingURL=useGetAccountOfferings.js.map